"use client";

import Typewriter from "@/components/components/Typewriter";
import Image from "next/image";

export default function Error() {
  return (
    <div className="h-screen grid place-content-center">
      <div className="flex flex-col gap-4 justify-center items-center text-lg pt-20">
        <Image
          src="/Sall-e2point001.png"
          alt="Sall-e"
          width={400}
          height={400}
        />

        <div className="max-w-full narrow-container relative top-[-1.5rem] text-center flex flex-col gap-4">
          <div className=" bg-[#CF4C67] text-white p-4 rounded-xl min-h-[55px] font-medium">
            <Typewriter
              text="Well that's awkward. My systems are malfunctioning. I should be back up and running to help you solve your problems shortly...or not...it's hard to tell with IT these days."
              onFinish={async () => {}}
              delay={50}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
